import styled from 'styled-components'

const Loading = styled.div`
    display: flex;
    flex: 1;
    padding: 20px;
    justify-content: center;
    align-items: center;
`
export default Loading
